import css from './GSFullDescriptionModal.module.scss'
import React from 'react'

import { IGoodServiceTicketData, Tap2GOTicketTicketStatus } from 'meta/pages/goodsandservices'

import Img from 'components/Media/Img'
import BalloonBox from 'components/TextBoxes/BalloonBox'

type Props = {
  data: IGoodServiceTicketData
}

const GSFullDescriptionModal: React.FC<Props> = (props) => {
  const { data } = props

  const ticketIconStatus = ![Tap2GOTicketTicketStatus.valid, Tap2GOTicketTicketStatus.checked].includes(
    data.status as Tap2GOTicketTicketStatus
  )
    ? 'error'
    : data.status

  const ticketIconPath = `${data?.event?.policy?.code}-icon-${ticketIconStatus}`

  return (
    <div className={css.outer_wrapper}>
      <BalloonBox infoType={'info'} noPadding>
        <div className={css.wrapper}>
          <div className={css.ticketIcon}>
            <Img src={`/goodsandservices/${ticketIconPath}.svg`} />
          </div>

          <div className={css.header}>
            <div className={css.title}>{data.notes}</div>
            <div className={css.description}>{data.webDetails}</div>
          </div>
        </div>
      </BalloonBox>
    </div>
  )
}

export default GSFullDescriptionModal
